import $ from 'legacy/jquery';
import UrlHelper from './url_helper';
import { isRunningInsideAndroidWebView } from './runner_detector';
import { IllegalStateError } from '../errors';

/**
 * THIS IS NOT TO BE INITIALIZED DIRECTLY (except for testing).
 *
 * It should be initialized indirectly via WebViewHelper
 *
 * Android WebViews unlike iOS webviews are much more powerful so
 * less information is sent to the app so less logic will be used
 * here than in the iOS
 *
 * The Android app has been designed to expose the methods under
 * `window.Android`
 *
 * @param {UrlHelper} urlHelper - a UrlHelper class instance to use for URL checks
 *
 * @see WebViewHelper
 * @see UrlHelper
 * @see iOS
 * */
export default function Android(urlHelper) {
  const self = this;
  let initialized = false;

  /**
   * Just an identifier for the app to tell what has been
   * initialized
   * */
  self.type = 'Android';

  function haveDeviceNavigateTo(opts) {
    window.Android.navigateTo(JSON.stringify(opts));
  }

  function haveDeviceDeeplinkTo(opts) {
    window.Android.deeplinkTo(JSON.stringify(opts));
  }

  function onLinkClick(evt) {
    const $elem = $(evt.currentTarget);
    let href = $elem.attr('href');

    // make sure to not let them navigate away from the page
    evt.preventDefault();

    if (
      urlHelper.isPlaceholderLink(href) ||
      !urlHelper.isAllowlistedLink($elem)
    ) {
      return;
    }

    // make sure to forcibly convert any invalid URL
    // marked external
    if (urlHelper.isExternalURL($elem)) {
      href = urlHelper.forceToAbsoluteURL(href);
    }

    // normalize the data before doing anything
    const data = urlHelper.getNormalizedDataFromLink($elem);

    if (data.handler === urlHelper.handlers.NAVIGATION) {
      delete data.handler;
      haveDeviceNavigateTo(data);
    } else {
      delete data.handler;
      haveDeviceDeeplinkTo(data);
    }
  }

  self.init = function () {
    if (!urlHelper || !(urlHelper instanceof UrlHelper)) {
      throw new TypeError('UrlHelper object param is not of the correct type');
    }

    if (!isRunningInsideAndroidWebView()) {
      throw new IllegalStateError('Android interface is not exposed!');
    }

    if (initialized) {
      return;
    }

    self.urlHelper = urlHelper;

    $(document).on('click', 'a', onLinkClick);

    initialized = true;
  };

  self.isInitialized = function () {
    return initialized;
  };

  /**
   * A manual method to allow users of the webview abstraction manually call the
   * navigate/deeplink handler. This is useful for when a navigation action needs to occur
   * outside of the user's action of clicking a link
   * */
  self.haveDeviceNavigateTo = function (url, title, isForNativeScreen) {
    const data = urlHelper.getNormalizedData(
      url,
      urlHelper.handlers.NAVIGATION,
      title,
      isForNativeScreen
    );

    // the handler name isn't needed by android so
    // delete it
    delete data.handler;
    haveDeviceNavigateTo(data);
  };

  self.haveDeviceDeeplinkTo = function (url, title, isForNativeScreen) {
    const data = urlHelper.getNormalizedData(
      url,
      urlHelper.handlers.DEEPLINK,
      title,
      isForNativeScreen
    );

    // the handler name isn't needed by android so
    // delete it
    delete data.handler;
    haveDeviceDeeplinkTo(data);
  };

  /**
   * For third parties to report to android the progress
   * in (%) of some ajax call
   * */
  self.reportProgress = function (progress) {
    window.Android.hasLoaded(progress);
  };

  self.destroy = function () {
    if (initialized) {
      $(document).off('click', 'a', onLinkClick);
      initialized = false;
    }
  };
}
